import React, { useContext, useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { Container } from 'react-bootstrap';
import Title from '../Title/Title';
import PortfolioContext from '../../context/context';
import pipedriveLogo from '../../images/pipedrive.png';
import imsLogo from '../../images/ims-logo.png'
import tuLogo from '../../images/tartu-university.png'

const logoAssets = {
  pipedrive: pipedriveLogo,
  ims: imsLogo,
  tartu: tuLogo
};

const Timeline = () => {
  const { timeline } = useContext(PortfolioContext);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsDesktop(false);
      setIsMobile(true);
    }
  }, []);

  return (
    <section id="journey">
      <Container>
        <Title title="what have I been up to?" />
        <div className="timeline" aria-label="Career timeline">
          {timeline.map(({ id, year, organization, content, description, logo, logoLabel }, index) => {
            const logoSource = logoAssets[logo];
            const contentBlocks = Array.isArray(content)
              ? content
              : description
              ? [{ type: 'text', value: description }]
              : [];

            return (
              <Fade
                key={id}
                left={isDesktop}
                bottom={isMobile}
                duration={700}
                delay={250 + index * 150}
                distance="20px"
              >
                <article className="timeline__item">
                  <div className="timeline__meta">
                    <span className="timeline__year">{year}</span>
                    <span className="timeline__node" aria-hidden="true" />
                  </div>
                  <div className="timeline__logo">
                    {logoSource ? (
                      <img src={logoSource} alt={`${organization} logo`} />
                    ) : (
                      <span>{logoLabel}</span>
                    )}
                  </div>
                  <div className="timeline__connector" aria-hidden="true" />
                  <div className="timeline__card">
                    <p className="timeline__organization">{organization}</p>
                    {contentBlocks.map((block, blockIndex) => {
                      if (block.type === 'links') {
                        if (!block.items || block.items.length === 0) return null;

                        return (
                          <ul className="timeline__links" key={`links-${blockIndex}`}>
                            {block.items.map(({ label, url }) => (
                              <li key={url}>
                                <a href={url} target="_blank" rel="noopener noreferrer">
                                  {label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        );
                      }

                      return (
                        <p className="timeline__description" key={`text-${blockIndex}`}>
                          {block.value}
                          {block.link && (
                            <>
                              {' '}
                              <a
                                className="timeline__inline-link"
                                href={block.link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {block.link.label}
                              </a>
                            </>
                          )}
                          {block.suffix}
                        </p>
                      );
                    })}
                  </div>
                </article>
              </Fade>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Timeline;
